import styled, { css, keyframes } from "styled-components";

const progressBorderAnimation = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const Label = styled.span`
  border-radius: 30px;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  transition: color 0.2s ease-in-out;
  line-height: 20px;
`;

export const StyledButton = styled.button<{
  $isActive: boolean;
  $playbackTime: number;
  $variant: "primary" | "secondary";
  $isAnimationActive?: boolean;
}>`
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 30px;
  border: none;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.25);
  cursor: pointer;
  display: flex;
  gap: 4px;
  height: 32px;
  justify-content: center;
  padding: 0 16px;
  position: relative;
  backdrop-filter: blur(7.5px);

  &:hover {
    ${Label} {
      color: ${({ theme, $variant }) =>
        $variant === "primary" ? theme.colors.white : "#3B3F45"};
    }
  }

  #progress-animation-svg {
    height: 100%;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  ${({ $variant }) =>
    $variant === "secondary" &&
    css`
      background: transparent;
      box-shadow: inset 0 0 0 1px #c2c6cb;

      ${Label} {
        color: #808893;
      }

      ${IconWrapper} svg {
        color: #808893;
      }
    `}

  ${({ $isActive, $playbackTime, $variant, theme }) =>
    $isActive &&
    $playbackTime &&
    css`
      pointer-events: none;

      ${Label} {
        color: ${$variant === "primary"
          ? theme.colors.white
          : theme.colors.primaryBlue} !important;
      }

      ${IconWrapper} svg {
        color: ${$variant === "primary"
          ? theme.colors.white
          : theme.colors.primaryBlue};
      }
    `}

    ${({ $isAnimationActive, $isActive, $playbackTime, $variant, theme }) =>
    $isAnimationActive &&
    $isActive &&
    css`
      #progress-animation-svg {
        opacity: 1;
      }

      rect {
        animation: ${progressBorderAnimation} ${$playbackTime}s linear both;
        stroke: ${$variant === "primary"
          ? "#D9D9D9"
          : theme.colors.primaryBlue};
      }
    `}
`;
